import { ModuleWithProviders, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { GalleryComponent } from './gallery.component';
import { NgbModule } from "@ng-bootstrap/ng-bootstrap";
import { SharedModule } from "../shared/shared.module";
import { RouterModule } from "@angular/router";
import { VideoDetailComponent } from './video-detail/video-detail.component';
import { PhotoDetailComponent } from './photo-detail/photo-detail.component';

@NgModule({
    imports: [
        CommonModule,
        NgbModule.forRoot(),
        SharedModule,
        RouterModule
    ],
    providers: [],
    declarations: [
        GalleryComponent,
        VideoDetailComponent,
        PhotoDetailComponent
    ]
})
export class GalleryModule {
    static forRoot(): ModuleWithProviders {
        return {
            ngModule: GalleryModule,
            providers: [],
        }
    }
}



// WEBPACK FOOTER //
// /Users/dominik/Documents/projekty/guru-monarch-beach-resort/guru-monarch-beach-resort/src/app/gallery/gallery.module.ts